// Use same-origin API on public domains. REACT_APP_HOST is only for local dev
// (localhost:3002); never send browser traffic to 127.0.0.1 from urrank.ir.
const resolveApiHost = () => {
    const configured = (process.env.REACT_APP_HOST || "").replace(/\/$/, "");

    if (typeof window === "undefined") {
        return configured;
    }

    const origin = window.location.origin;
    if (!configured) {
        return origin;
    }

    try {
        const configuredHost = new URL(configured).hostname;
        const pageHost = window.location.hostname;
        const devHosts = new Set(["localhost", "127.0.0.1", "backend"]);
        if (devHosts.has(configuredHost) && !devHosts.has(pageHost)) {
            return origin;
        }
    } catch {
        return origin;
    }

    return configured;
};

export const HOST = resolveApiHost();

export const LOGIN_ADDRESS = `${HOST}/api/v1/o/token/`;
export const REGISTER_ADDRESS = `${HOST}/api/v1/company/users/register/`;
export const SEND_OTP = `${HOST}/api/v1/company/users/send-otp/`;
export const COMPANY_REGISTER_TYPE_LIST = `${HOST}/api/v1/company/company-categoreis/list/`;
export const COMPANY_BUSINESS_TYPE_TREE = `${HOST}/api/v1/company/company-categoreis/tree/`;
export const COMPANY_REGISTER_ADDRESS = `${HOST}/api/v1/company/companies/register/`;
export const CHANGE_PASS = `${HOST}/api/v1/company/users/change-pass/`;

// SETTING APIs:
export const SETTING_ITEMS_TYPE = `${HOST}/api/v1/feedback/item-types/`;
export const SETTING_ITEMS_TYPE_TREE = `${HOST}/api/v1/feedback/item-types/tree/`;
export const SETTING_ITEMS_TYPE_AI_GENERATE = `${HOST}/api/v1/feedback/item-types/ai-generate-tree/`;
export const SETTING_ITEMS_TYPE_AI_APPLY = `${HOST}/api/v1/feedback/item-types/ai-apply-tree/`;
export const SETTING_ITEMS_TYPE_FAETURES = `${HOST}/api/v1/feedback/item-type-features/`;
export const SETTING_ITEMS_TYPE_FAETURES_LIST = `${HOST}/api/v1/feedback/item-type-features/list/`;
export const SETTING_FEATURES = `${HOST}/api/v1/feedback/features/`;
export const SETTING_FEATURES_LIST = `${HOST}/api/v1/feedback/features/list/`;
export const SETTING_ITEMS = `${HOST}/api/v1/feedback/items/`;
export const SETTING_ITEMS_LIST = `${HOST}/api/v1/feedback/items/list/`;

export const SETTING_ITEM_QR_CODE = `${HOST}/api/v1/feedback/items/{id}/qr-code/`;
export const SETTING_FORMS = `${HOST}/api/v1/feedback/forms/`;
export const SETTING_FORMS_LIST = `${HOST}/api/v1/feedback/forms/list/`;
export const SETTING_FORMS_AI_GENERATE = `${HOST}/api/v1/feedback/forms/ai-generate-form/`;
export const SETTING_FORMS_AI_APPLY = `${HOST}/api/v1/feedback/forms/ai-apply-form/`;

// SURVEY APIs:
export const SURVEY_LIST = `${HOST}/api/v1/survey/surveys/`;
export const SURVEY_ITEM_TYPE_FORMS = `${SURVEY_LIST}item-type-forms/`;
export const SURVEY_AI_GENERATE = `${HOST}/api/v1/survey/surveys/ai-generate/`;
export const SURVEY_TEMPLATES = `${HOST}/api/v1/survey/templates/`;
export const SURVEY_CAMPAIGNS = `${HOST}/api/v1/survey/campaigns/`;
export const SURVEY_CAMPAIGNS_AI_GENERATE_MESSAGE = `${SURVEY_CAMPAIGNS}ai-generate-message/`;
export const SURVEY_SENDER_PROFILES = `${HOST}/api/v1/survey/sender-profiles/`;
export const SURVEY_SUPPRESSIONS = `${HOST}/api/v1/survey/suppressions/`;
export const SURVEY_INVITATIONS = `${HOST}/api/v1/survey/invitations/`;
export const SURVEY_PUBLIC = `${HOST}/api/v1/survey/public/`;
export const SURVEY_PHONE_CALLS = `${HOST}/api/v1/survey/phone-calls/`;
export const surveyDetailUrl = (id) => `${SURVEY_LIST}${id}/`;
export const surveyActionUrl = (id, action) =>
    `${SURVEY_LIST}${id}/${action}/`;
export const surveyCampaignUrl = (id, action) =>
    `${SURVEY_CAMPAIGNS}${id}/${action}/`;
export const surveyPhoneCallUrl = (id, action) =>
    `${SURVEY_PHONE_CALLS}${id}/${action}/`;
export const surveyPublicUrl = (token) => `${SURVEY_PUBLIC}${token}/`;
export const surveyPublicContentUrl = (token) =>
    `${SURVEY_PUBLIC}${token}/content/`;
export const surveyPublicSubmitUrl = (token) =>
    `${SURVEY_PUBLIC}${token}/submit/`;
const surveyPwaBasePath = () => {
    const base = (process.env.PUBLIC_URL || "").replace(/^\/|\/$/g, "");
    return base ? `/${base}` : "";
};
export const surveyPublicPageUrl = (publicPath) => {
    const path = publicPath.startsWith("/")
        ? publicPath
        : `/survey/${publicPath}`;
    const origin =
        typeof window !== "undefined" ? window.location.origin : "";
    return `${origin}${surveyPwaBasePath()}${path}`;
};
export const SETTING_FORMS_CRITERIA = `${HOST}/api/v1/feedback/form-criteria-list/`;
export const SETTING_FORMS_USER_GROUP = `${HOST}/api/v1/company/user-groups/list/`;

export const SETTING_IMPORT_ITEMS_EXCEL = `${HOST}/api/v1/feedback/items/{id}/example/`;
export const SETTING_EDIT_ITEMS_EXCEL = `${HOST}/api/v1/feedback/items/{id}/example-edit/`;
export const SETTING_IMPORT_ITEMS_POST = `${HOST}/api/v1/feedback/items/{id}/import/`;
export const SETTING_EDIT_ITEMS_POST = `${HOST}/api/v1/feedback/items/{id}/import-edit/`;
export const SETTING_CRITERIA_TEMPLATE_LIST = `${HOST}/api/v1/feedback/criteria-state-templates/list/`;
export const SETTING_CERITERIA_LIST = `${HOST}/api/v1/feedback/criterias/list/`;
export const FEEDBACK_PAGE_SECTIONS = `${HOST}/api/v1/feedback/feedback-page-sections/settings/`;
export const FEEDBACK_PRINT_POSTER_AI = `${HOST}/api/v1/feedback/feedback-page-sections/ai-generate-print-poster/`;
export const itemPrintPosterUrl = (id) =>
    `${HOST}/api/v1/feedback/items/${id}/print-poster/`;
export const itemQrCodeUrl = (id) =>
    `${HOST}/api/v1/feedback/items/${id}/qr-code/`;

export const SETTING_TEMPLATE_GET = `${HOST}/api/v1/feedback/pattern-types/`;
export const SETTING_TEMPLATE_CREATE = `${HOST}/api/v1/feedback/pattern-types/generate-pattern/`;
export const SETTING_TEMPLATE_WATCHDOG = `${HOST}/api/v1/feedback/pattern-types/generate-status/`;
export const SETTING_TEMPLATE_PREVIEW = `${HOST}/api/v1/feedback/pattern-types/`;
export const SETTING_AI_EXPERIENCE_SESSIONS = `${HOST}/api/v1/feedback/ai-experience-sessions/`;
export const SETTING_AI_EXPERIENCE_ACTIVE = `${HOST}/api/v1/feedback/ai-experience-sessions/active/`;

//FEEDBACK APIs:
export const FEEDBACK_LIST_URL = `${HOST}/api/v1/feedback/feedbacks/`;
export const FEEDBACK_AI_SUMMARY_URL = `${HOST}/api/v1/feedback/feedbacks/ai-summary/`;
export const FEEDBACK_AI_SUMMARY_USERS_URL = `${HOST}/api/v1/feedback/feedbacks/ai-summary/users/`;
export const FEEDBACK_AI_SUMMARY_HISTORY_URL = `${HOST}/api/v1/feedback/feedbacks/ai-summary/history/`;
export const USER_FEEDBACK_LIST_URL = `${HOST}/api/v1/feedback/feedbacks/user-panel/`;
export const FEEDBACK_SINGLE_URL = `${HOST}/api/v1/feedback/feedbacks/{id}/`;
export const USER_FEEDBACK_SINGLE_URL = `${HOST}/api/v1/feedback/feedbacks/user-panel/{id}/`;
export const FEEDBACK_LIKE_URL = `${HOST}/api/v1/feedback/feedbacks/{id}/likes/`;
export const FEEDBACK_DISLIKE_URL = `${HOST}/api/v1/feedback/feedbacks/{id}/dislikes/`;
export const FEEDBACK_ADD_BOOKMARK_URL = `${HOST}/api/v1/feedback/feedback-bookmarks/`;
export const FEEDBACK_REMOVE_BOOKMARK_URL = `${HOST}/api/v1/feedback/feedback-bookmarks/{id}/`;

// AUTOMATION APIs:
export const FEEDBACK_STATUS_LIST = `${HOST}/api/v1/automation/feedback-status/?feedback={id}`;
export const FEEDBACK_STATUS_LIST_ASSIGN_GROUPS = `${HOST}/api/v1/automation/automation-groups/assign-groups/{id}/`;
export const FEEDBACK_STATUS_PICKUP = `${HOST}/api/v1/automation/feedback-status/{id}/pickup/`;
export const FEEDBACK_STATUS_WORKFLOW = `${HOST}/api/v1/automation/feedback-status-workflows/{id}/`;
export const FEEDBACK_STATUS_CLOSE = `${HOST}/api/v1/automation/feedback-status/{id}/close/`;
export const FEEDBACK_STATUS_ASSIGN = `${HOST}/api/v1/automation/feedback-status/{id}/assign/`;
export const FEEDBACK_STATUS_REPORT = `${HOST}/api/v1/automation/feedback-status-histories/?feedback_status={id}`;
export const USER_FEEDBACK_STATUS_REPORT = `${HOST}/api/v1/automation/feedback-status-histories/user-panel/?feedback={id}`;

// COMPANY APIs:
export const COMPANY_DETAIL = `${HOST}/api/v1/company/companies/{id}/`;
export const COMPANY_ROLE = `${HOST}/api/v1/company/company-roles/`;
export const GET_USER_OF_COMPANY = `${HOST}/api/v1/company/users/list/{id}/`;
export const GET_COMPANY_ROLES_LIST = `${HOST}/api/v1/company/company-roles/list/`;
export const COMPANY_MEMBERS = `${HOST}/api/v1/company/users/members/`;
export const COMPANY_CREATE_MEMBER = `${HOST}/api/v1/company/users/create-member/`;
export const COMPANY_IMPORT_MEMBERS = `${HOST}/api/v1/company/users/import-members/`;
export const COMPANY_MEMBERS_TEMPLATE = `${HOST}/api/v1/company/users/members-template/`;
export const companyMemberSetAdminUrl = (id) =>
    `${HOST}/api/v1/company/users/${id}/set-admin/`;
export const companyMemberUpdateUrl = (id) =>
    `${HOST}/api/v1/company/users/${id}/update-member/`;
export const companyMemberRemoveUrl = (id) =>
    `${HOST}/api/v1/company/users/${id}/remove-member/`;

// INCENTIVES AND WALLET:
// Keep this boundary centralized: deployments may expose equivalent actions
// under slightly different REST names.
export const WALLET_BASE = `${HOST}/api/v1/wallet/`;
export const WALLET_SUMMARY = `${WALLET_BASE}summary/`;
export const WALLET_COIN_PRICES = `${WALLET_BASE}coin-prices/`;
export const WALLET_COIN_PRICE_CURRENT = `${WALLET_COIN_PRICES}current/`;
export const WALLET_COIN_QUOTE = `${WALLET_BASE}coin-purchases/quote/`;
export const WALLET_COIN_PURCHASES = `${WALLET_BASE}coin-purchases/`;
export const WALLET_COIN_VERIFY = `${WALLET_BASE}coin-purchases/verify-zarinpal/`;
export const WALLET_AI_TARIFFS = `${WALLET_BASE}ai-usage-tariffs/`;
export const WALLET_AI_TARIFF_QUOTE = `${WALLET_AI_TARIFFS}quote/`;
export const WALLET_AI_TARIFF_BULK = `${WALLET_AI_TARIFFS}bulk-update/`;
export const INCENTIVES_BASE = `${HOST}/api/v1/incentives/`;
export const INCENTIVE_DASHBOARD = `${INCENTIVES_BASE}dashboard/`;
export const INCENTIVE_CAMPAIGNS = `${INCENTIVES_BASE}campaigns/`;
export const INCENTIVE_REVIEW_QUEUE = `${INCENTIVES_BASE}reviews/`;
export const INCENTIVE_LEDGER = `${INCENTIVES_BASE}ledger/`;
export const INCENTIVE_OPPORTUNITIES = `${INCENTIVES_BASE}opportunities/effective/`;
export const INCENTIVE_REWARD_STATUS = `${INCENTIVES_BASE}rewards/status/`;
export const INCENTIVE_NOTIFICATIONS = `${HOST}/api/v1/notification/notifications/`;
export const incentiveCampaignUrl = (id, action) =>
    `${INCENTIVE_CAMPAIGNS}${id}/${action ? `${action}/` : ""}`;
export const incentiveReviewUrl = (id, action) =>
    `${INCENTIVE_REVIEW_QUEUE}${id}/${action}/`;

// AUTOMATION GROUPS
export const GET_AUTOMATION_GROUPS = `${HOST}/api/v1/automation/automation-groups/{id}/`;
export const GET_AUTOMATION_GROUP_LIST = `${HOST}/api/v1/automation/automation-groups/list/{id}/`;
export const GET_AUTOMATION_GROUP = `${HOST}/api/v1/automation/automation-groups/`;
export const AUTOMATION_GROUPS_AI_GENERATE = `${HOST}/api/v1/automation/automation-groups/ai-generate/`;
export const AUTOMATION_GROUPS_AI_APPLY = `${HOST}/api/v1/automation/automation-groups/ai-apply/`;
export const AUTOMATION_GROUPS_AI_ASSIGN_ITEM_TYPES = `${HOST}/api/v1/automation/automation-groups/ai-assign-item-types/`;

// REPORT APIs:
export const REPORT_FEEDBACK_STATISTICS = `${HOST}/api/v1/report/company/item_type_feedbacks/`;
export const REPORT_BASIC = `${HOST}/api/v1/report/company/basic/`;
export const REPORT_HAPPINESS = `${HOST}/api/v1/report/company/feedbacks_score_range/`;
export const REPORT_AVERAGE = `${HOST}/api/v1/report/company/avg_feedbacks_reply/`;
export const REPORT_GET_TILES = `${HOST}/api/v1/report/company/item_or_item_type_score/`;
export const REPORT_GET_ITEM_TREE = `${HOST}/api/v1/report/company/item_tree/`;
export const REPORT_GET_ITEM_TYPE_TREE = `${HOST}/api/v1/report/company/item_type_tree/`;
export const REPORT_GET_CRITERIA_TREE = `${HOST}/api/v1/report/company/criteria_tree/`;

export const REPORT_PER_DAY = `${HOST}/api/v1/feedback/feedbacks/feedbacks-as-days/`;
export const REPORT_SCORE_OVERVIEW = `${HOST}/api/v1/feedback/feedbacks/feedback-count-scores/`;
export const REPORT_FEEDBACKS = `${HOST}/api/v1/automation/feedback-status/report-as-status/`;
export const REPORT_BUBBLE = `${HOST}/api/v1/feedback/item-types/bubble-chart/`;
export const REPORT_ITEM_RANKING = `${HOST}/api/v1/feedback/items/ranking/`;
export const REPORT_CRITERIA_RANKING = `${HOST}/api/v1/feedback/criterias/ranking/`;
export const REPORT_SCORE_BREAKDOWN = `${HOST}/api/v1/feedback/feedbacks/score-breakdown/`;

export const REPORT_AI_SUGGESTIONS = `${HOST}/api/v1/report/company/ai-suggestions/`;
export const REPORT_BASED_ON_ITEM = `${HOST}/api/v1/report/company/feedback_basis_on_item/`;
export const REPORT_BASED_ON_ITEM_TYPE = `${HOST}/api/v1/report/company/feedback_basis_on_item_type/`;
export const REPORT_BASED_ON_TIME = `${HOST}/api/v1/report/company/feedback_basis_on_time/`;
export const REPORT_BASED_ON_CRITERIA = `${HOST}/api/v1/report/company/feedback_basis_on_criteria/`;
export const REPORT_PERFORMANCE_SCORE_USER = `${HOST}/api/v1/report/company/score_basis_on_user/`;
export const REPORT_PERFORMANCE_SCORE_GROUP = `${HOST}/api/v1/report/company/score_basis_on_group/`;
export const REPORT_PERFORMANCE_AVG_USER = `${HOST}/api/v1/report/company/avg_reply_on_user/`;
export const REPORT_PERFORMANCE_AVG_GROUP = `${HOST}/api/v1/report/company/avg_reply_on_group/`;
export const REPORT_PERFORMANCE_FEEDBACK_USER = `${HOST}/api/v1/report/company/number_of_feedbacks_basis_on_user/`;
export const REPORT_PERFORMANCE_FEEDBACK_GROUP = `${HOST}/api/v1/report/company/number_of_feedbacks_basis_on_group/`;

// REST:
export const CERITERIA_LIST_URL = `${HOST}/api/v1/feedback/criterias/`;
export const TEMPLATE_LIST = `${HOST}/api/v1/feedback/criteria-state-templates/`;
export const COMPANY_LIST_URL = `${HOST}/api/v1/company/companies/`;
export const USER_GRIOUP_LIST = `${HOST}/api/v1/company/user-groups/`;

//Club
export const COMPANY_CLUBS = `${HOST}/api/v1/club/company-clubs/?page={id}/`;
export const COMPANY_CLUBS_BASE = `${HOST}/api/v1/club/company-clubs/`;
export const COMPANY_CLUBS_SUMMARY = `${HOST}/api/v1/club/company-clubs/members-summary/`;
export const COMPANY_CLUBS_EXPORT = `${HOST}/api/v1/club/company-clubs/export/`;
export const COMPANY_CLUB_ACTIVITY = `${HOST}/api/v1/club/company-clubs/{id}/activity/`;
export const SEARCH_CARD = `${HOST}/api/v1/club/company-clubs/?page={id}/{id}/`;
export const ADD_USER_COMPANY = `${HOST}/api/v1/club/company-clubs/`;
export const DELETE_USER_COMPANY = `${HOST}/api/v1/club/company-clubs/{id}/`;
export const SET_CLUB_MEMBER_USER_GROUP = `${HOST}/api/v1/club/company-clubs/{id}/set-user-group/`;
export const EDIT_USER_COMPANY = `${HOST}/api/v1/club/company-clubs/{id}/`;
export const GET_ONE_USER_COMPANY = `${HOST}/api/v1/club/company-clubs/{id}/`;
export const DISCOUNT_CARD = `${HOST}/api/v1/club/discount-card/`;
export const ADD_DISCOUNT_CARD = `${HOST}/api/v1/club/discount-card/`;
export const GET_ONE_DISCOUNT_CARD = `${HOST}/api/v1/club/discount-card/{id}/`;
export const EDIT_DISCOUNT_CARD = `${HOST}/api/v1/club/discount-card/{id}/`;
export const DELETE_DISCOUNT_CARD = `${HOST}/api/v1/club/discount-card/deactive/{id}/`;
export const CONTENT_CARD = `${HOST}/api/v1/club/contents/`;
export const ADD_CONTENT_CARD = `${HOST}/api/v1/club/contents/`;
export const DELETE_CONTENT_CARD = `${HOST}/api/v1/club/contents/{id}/`;
export const EDIT_CONTENT_CARD = `${HOST}/api/v1/club/contents/{id}/`;
export const GET_ONE_OFFER_CARD = `${HOST}/api/v1/club/contents/{id}/`;
export const CONTENT_STUDIO_ANALYTICS = `${HOST}/api/v1/club/contents/analytics/`;
export const CONTENT_STUDIO_ADMIN_QUEUE = `${HOST}/api/v1/club/contents/admin-queue/`;
export const contentStudioUrl = (id, action) =>
    action
        ? `${HOST}/api/v1/club/contents/${id}/${action}/`
        : `${HOST}/api/v1/club/contents/${id}/`;
export const COMPANY_CLUB_GROUPS = `${HOST}/api/v1/club/company-club-groups/`;
export const ADD_NEW_GROUP = `${HOST}/api/v1/club/company-club-groups/`;
export const DELETE_GROUP_CLUB = `${HOST}/api/v1/club/company-club-groups/{id}/`;
export const EDIT_GROUP_CLUB = `${HOST}/api/v1/club/company-club-groups/{id}/`;
export const GET_REPORT_JOINED_CLUB = `${HOST}/api/v1/club/company-clubs/report/`;
export const GET_REPORT_SHARE_CONTENT = `${HOST}/api/v1/club/contents/report/`;
export const SHARE_SOCIAL_MEDIA = `${HOST}/api/v1/club/content-share-link/`;
export const SHARE_MEMBERS = `${HOST}/api/v1/club/content-share-memebers/`;
export const SHARE_GROUPS = `${HOST}/api/v1/club/content-share-groups/`;
export const GET_SHARE_LINK = `${HOST}/api/v1/club/content-share-link/:id/`;
export const SALE_CARD_DATA = `${HOST}/api/v1/market/sale-carts/list/`;

export const USED_DISCOUNT_CARD_LIST = `${HOST}/api/v1/club/used-discount-cards/`;
export const DEACTIVATE_USED_DISCOUNT_CARD = `${HOST}/api/v1/club/used-discount-cards/deactive/{id}/`;
export const COMPANY_LIST = `${HOST}/api/v1/club/discount-card/company/`;

// Profile
export const GET_USER_TYPE_TREE = `${HOST}/api/v1/company/users/list/{id}/`;
export const GET_COMPANY_RULES_TREE = `${HOST}/api/v1/company/company-roles/tree/{id}/`;
export const GET_PACKAGES = `${HOST}/api/v1/company/packages/list/`;
export const VALIDATE_DISCOUNT = `${HOST}/api/v1/company/package-discounts/validate/`;
export const GET_PACKAGE_LOGS = `${HOST}/api/v1/company/package-logs/`;
export const BUY_PACKAGE = `${HOST}/api/v1/company/package-logs/`;

//ScoreManagement
export const GET_ASSIGN_COIN_ITEM = `${HOST}/api/v1/club/assign-user-coin/`;
export const GET_COMPANY_COINS = `${HOST}/api/v1/club/assign-company-user-coin/`;
export const EDIT_COMPANY_COINS = `${HOST}/api/v1/club/assign-company-user-coin/{id}/`;
export const EDIT_COIN_NUMBER = `${HOST}/api/v1/club/assign-user-coin/{id}/`;
export const BUY_SELL_ORDER_EX = `${HOST}/api/v1/club/exchange/company/`;
export const ORDERS_IN_PROCCESS = `${HOST}/api/v1/club/exchange/company/`;
export const GET_COMPANY_MONEY_COINS = `${HOST}/api/v1/club/accounts/company/`;
export const GET_ALL_ORDERS = `${HOST}/api/v1/club/exchange/`;
export const DELETE_ORDER = `${HOST}/api/v1/club/exchange/company/{id}/`;
export const ORDERS_TRANSACTION = `${HOST}/api/v1/club/exchange-transaction/company/?page={id}/`;

//Excel Download Links
export const FEEDBACK_EXCEL = `${HOST}/api/v1/feedback/feedbacks/export/{id}/`;

//UserProfile

export const GET_USER_PROFILE = `${HOST}/api/v1/company/users/profile/get/`;
export const EDIT_PROFILE_DATA = `${HOST}/api/v1/company/users/profile/edit/`;

//User Feedbacks
export const USER_FEEDBACKS = `${HOST}/api/v1/feedback/feedbacks/user-panel/`;

//User Exchange

export const BUY_SELL_ORDER_UR = `${HOST}/api/v1/club/exchange/user-create/`;
export const ORDERS_IN_PROCCESS_UR = `${HOST}/api/v1/club/exchange/user/`;
export const GET_USER_MONEY_COINS_UR = `${HOST}/api/v1/club/accounts/user/`;
export const GET_ALL_ORDERS_UR = `${HOST}/api/v1/club/exchange/`;
export const DELETE_ORDER_UR = `${HOST}/api/v1/club/exchange/company/{id}/`;

export const ORDERS_TRANSACTION_UR = `${HOST}/api/v1/club/exchange-transaction/user/?page={id}/`;

//CLUB USERS DOWNLOAD AND UPLOAD

export const EXPORT_CLUB_USERS = `${HOST}/api/v1/club/company-clubs/example/`;
export const IMPORT_CLUB_USERS = `${HOST}/api/v1/club/company-clubs/import/`;

//GET COMPANY ROLE TREE
export const COMPANY_ROLES = `${HOST}/api/v1/club/company-clubs/import/`;

//FEEDBACK_STATUS
export const GET_FEEDBACK_COUNTS = `${HOST}/api/v1/feedback/feedbacks/feedback-count/`;
export const USER_GET_FEEDBACK_COUNTS = `${HOST}/api/v1/feedback/feedbacks/user-panel/feedback-counts/`;
export const GET_SEND_FEEDBACK_LIST = `${HOST}/api/v1/feedback/feedbacks/sent/`;
export const GET_MONITORING_FEEDBACK_LIST = `${HOST}/api/v1/feedback/feedbacks/monitoring/`;
export const GET_RECEIVED_FEEDBACK_LIST = `${HOST}/api/v1/feedback/feedbacks/received/`;

//RESRT PASSWORD
export const RESET_PASSWORD = `${HOST}/api/v1/company/users/reset-pass-otp/`;

//AUTOMATION
export const CLOSE_MESSAGE_AUTOMATION = `${HOST}/api/v1/automation/feedback-status/{id}/close/`;

//GET EDIT COMPANY INFO
export const GET_COMPANY_INFO = `${HOST}/api/v1/company/companies/`;
export const EDIT_COMPANY_INFO = `${HOST}/api/v1/company/companies/{id}/`;
export const EDIT_COMPANY_TRANSLATES = `${HOST}/api/v1/company/company-translates/{id}/`;
export const DELETE_COMPANY_TRANSLATES = `${HOST}/api/v1/company/company-translates/{id}/`;

//ORGANIZATION MANAGEMENT (superuser)
export const ADMIN_COMPANY_LIST = `${HOST}/api/v1/company/companies/admin-list/`;
export const ADMIN_COMPANY_CREATE = `${HOST}/api/v1/company/companies/`;
export const ADMIN_COMPANY_DETAIL = `${HOST}/api/v1/company/companies/{id}/`;
export const ADMIN_COMPANY_AVAILABLE_ADMINS = `${HOST}/api/v1/company/companies/available-admin-users/`;
export const ADMIN_COMPANY_DELETE = `${HOST}/api/v1/company/companies/{id}/`;
export const ADMIN_COMPANY_ENTER_AS_ADMIN = `${HOST}/api/v1/company/companies/{id}/enter-as-admin/`;
export const ADMIN_COMPANY_SUSPEND = `${HOST}/api/v1/company/companies/{id}/suspend/`;
export const ADMIN_COMPANY_RESTORE = `${HOST}/api/v1/company/companies/{id}/restore/`;
export const ADMIN_COMPANY_ADD_COINS = `${HOST}/api/v1/company/companies/{id}/add-coins/`;
export const ADMIN_PACKAGE_LIST = `${HOST}/api/v1/company/packages/admin-list/`;
export const ADMIN_PACKAGE_CREATE = `${HOST}/api/v1/company/packages/`;
export const ADMIN_PACKAGE_DETAIL = `${HOST}/api/v1/company/packages/{id}/`;
export const ADMIN_USER_LIST = `${HOST}/api/v1/company/users/admin-list/`;
export const ADMIN_USER_CREATE = `${HOST}/api/v1/company/users/admin-create/`;
export const ADMIN_USER_ACCESS = `${HOST}/api/v1/company/users/{id}/access/`;
export const ADMIN_USER_SET_ACTIVE = `${HOST}/api/v1/company/users/{id}/set-active/`;
export const ADMIN_USER_ENTER = `${HOST}/api/v1/company/users/{id}/enter-as-user/`;

//MARKET APIS
export const GET_MARKET_ITEMS = `${HOST}/api/v1/market/items/`;
export const GET_MARKET_CATEGORIES = `${HOST}/api/v1/market/categories/tree/`;
export const GET_MARKET_BASKET = `${HOST}/api/v1/market/sale-carts/`;
export const SAVE_MARKET_BASKET = `${HOST}/api/v1/market/sale-carts/:id/`;
export const DELETE_MARKET_BASKET = `${HOST}/api/v1/market/sale-carts/:id/`;
export const DELETE_MARKET_PRICE = `${HOST}/api/v1/market/sale-cart-prices/:id/`;
export const EDIT_MARKET_PRICE = `${HOST}/api/v1/market/sale-cart-prices/:id/`;

// USER CLUB
export const USER_PANEL_CLUB = `${HOST}/api/v1/club/company-clubs/user-clubs/`;
export const USER_PANEL_CLUB_CONTENT_PER_COMPANY = `${HOST}/api/v1/club/contents/company/:id/`;
export const GET_CLUB_CONTENT = `${HOST}/api/v1/club/contents/:id/user-panel/`;
export const GET_CLUB_COMMENT = `${HOST}/api/v1/club/content-comments/?content=:id`;
export const CLUB_LIKE_CONTENT = `${HOST}/api/v1/club/contents/:id/likes/`;
export const CLUB_DISLIKE_CONTENT = `${HOST}/api/v1/club/contents/:id/dislikes/`;
export const CLUB_SEND_COMMENT = `${HOST}/api/v1/club/content-comments/`;
export const CLUB_SEND_OTP = `${HOST}/api/v1/club/content-share-link/:id/send-otp/`;
export const CLUB_VERIFY_OTP = `${HOST}/api/v1/club/content-share-link/:id/validate-otp/`;

// USER DISCOUNT

export const DISCOUNT_LIST = `${HOST}/api/v1/club/discount-card/user-panel/`;
export const USED_DISCOUNT_LIST = `${HOST}/api/v1/club/used-discount-cards/user-panel/`;
export const DISCOUNT_LIST_OBJ = `${HOST}/api/v1/club/discount-card/user-panel/:id/`;
export const BUY_DISCOUNT = `${HOST}/api/v1/club/used-discount-cards/`;

// FOOD
export const GET_ALL_FOOD = `${HOST}/api/v1/menu/sale-cards/`;
export const GET_FOOD = `${HOST}/api/v1/menu/sale-cards/:id/`;
export const DELETE_FOOD = `${HOST}/api/v1/menu/sale-cards/:id/`;
export const CREATE_FOOD = `${HOST}/api/v1/menu/sale-cards/`;
export const EDIT_FOOD = `${HOST}/api/v1/menu/sale-cards/:id/`;
export const GET_ORDER_LIST_WITHOUT_PAGINATION = `${HOST}/api/v1/menu/orders/company-panel/`;
export const GET_USER_ORDERS = `${HOST}/api/v1/menu/orders/user-panel/`;
export const EDIT_ORDER_STATUS = `${HOST}/api/v1/menu/orders/:id/`;
export const USER_COIN_HISTORY = `${HOST}/api/v1/club/user-transaction-histories/`;
